import { GxIcon } from "./icon.js"

export class GxIconBriefCase extends GxIcon {

  constructor() {
    super()
    const templ = document.createElement("template")
    templ.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-briefcase h-4 w-4" aria-hidden="true"><path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path><rect width="20" height="14" x="2" y="6" rx="2"></rect></svg>
`
    super.addHTML(templ)
  }
}


if (!window.customElements.get("gx-icon-briefcase")) window.customElements.define("gx-icon-briefcase", GxIconBriefCase)
